var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefreshArrowsCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_refresh-circle",
    "data-name": "vuesax/bold/refresh-circle",
    transform: "translate(-684 -508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "refresh-circle",
    transform: "translate(684 508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H20V20H0Z",
    transform: "translate(20 20) rotate(180)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M8.667,0a8.667,8.667,0,1,0,8.667,8.667A8.67,8.67,0,0,0,8.667,0ZM3.987,8a4.7,4.7,0,0,1,7.644-3V4.177a.65.65,0,0,1,1.3,0V6.491a.655.655,0,0,1-.65.65H9.967a.65.65,0,1,1,0-1.3h.65a3.421,3.421,0,0,0-5.356,2.34.645.645,0,0,1-.641.555.355.355,0,0,1-.1-.009A.64.64,0,0,1,3.987,8Zm8.034,4.021a4.7,4.7,0,0,1-6.327.312v.815a.65.65,0,1,1-1.3,0V10.833a.655.655,0,0,1,.65-.65H7.358a.65.65,0,1,1,0,1.3h-.65a3.421,3.421,0,0,0,5.356-2.34.649.649,0,0,1,.737-.555.66.66,0,0,1,.555.737A4.754,4.754,0,0,1,12.021,12.021Z",
    transform: "translate(1.333 1.333)",
    fill: "#f4906a"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshArrowsCircle);
export default __webpack_public_path__ + "static/media/refresh-arrows_circle.bf769ce1b0398cb9ea7b4025d3b2148e.svg";
export { ForwardRef as ReactComponent };